import { useMemo } from "react";
import { Box, Center, Loader, Text } from "@mantine/core";
import BackNavigationButton from "../../../../common/components/BackNavigationButton/BackNavigationButton";
import CoverStoryView from "../CoverStoryView/CoverStoryView";
import { normalizePlanDetailData } from "../../utils/normalizePlanDetailData";

const SharedPlanDetail = ({
  data,
  isLoading,
  error,
  showBackButton = false,
  errorMessage = "Failed to load plan details.",
}) => {
  const normalizedData = useMemo(() => normalizePlanDetailData(data), [data]);

  if (isLoading) {
    return (
      <Center mt="lg">
        <Loader />
      </Center>
    );
  }

  if (error || !data) {
    return (
      <Text c="red" p="md">
        {errorMessage}
      </Text>
    );
  }

  return (
    <>
      {showBackButton ? <BackNavigationButton mb="md" /> : null}
      <Box bg="#f8fafc">
        <CoverStoryView data={normalizedData} />
      </Box>
    </>
  );
};

export default SharedPlanDetail;